import React, { useState, useEffect } from 'react';
import { View, ScrollView, Animated, Image, Text, TouchableOpacity, Modal, ActivityIndicator } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';
import activesService from '../../services/activesService';
import { LinearGradient } from "expo-linear-gradient";
import { MaterialIcons } from "@expo/vector-icons";
import NumberInput from '../../components/NumberInput';
import { formatGPXBalance, maxDecimals } from '../../utils/formatNumber'
import styles from './styles';

const CardsMyTokensWallet = ({ saldoGPX }) => {
    const [viewScale] = useState(new Animated.Value(600));
    const [selectecdAsset, setSelectedAsset] = useState({});
    const [selectecdAssetApiObj, setSelectedAssetApiObj] = useState({});
    const [certificateEmit, setCertificateEmit] = useState(false);
    const navigation = useNavigation();
    const [saldo, setSaldo] = useState(0);
    const [listActives, setListActives] = useState([]);
    const [loading, setLoading] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        if (selectecdAsset?.id) {
            setCertificateEmit(false);
            getBalanceCoin();
            getSelectedAssetApiInfo(selectecdAsset?.id);
        }
    }, [selectecdAsset]);

    useEffect(() => {
        getTokensWallet();
    }, [saldoGPX]);

    const getSelectedAssetApiInfo = async (activeId) => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        activesService.getById(token, activeId).then((response) => {
            if(response.data) {
                setSelectedAssetApiObj(response.data);
                if(response.data.actives.length > 0) {
                    if(response.data.actives[0].certificate) {
                        setCertificateEmit(true);
                    }
                }
            }
        });
    }

    const getBalanceCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        api.get(`balanceGpxcoin/${selectecdAsset.id}`, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                // console.log(res.data)
                setSaldo((Number(res.data.saldo)));
            })
            .catch((error) => {
                // console.log("erro3", error);
            })
    }

    const BalanceInfo = () => (
        <View style={styles.balance_info_container}>
            <View>
                <Text style={styles.balance_info_title}>Saldo</Text>
                <Text style={styles.balance_info_value}>{maxDecimals(saldo, 8)} {selectecdAsset.name_token}</Text>
            </View>
        </View>
    );

    const ActionButtons = () => {
        const [qtd, setQtd] = useState(0);

        return (
            <>
                <View style={styles.contentPurchase}>
                    <Text style={styles.titlePurchase}>Quanto deseja?</Text>
                    <View style={styles.contentPurchaseAmount}>
                        <NumberInput
                            minValue={0}
                            value={qtd}
                            onChange={value => setQtd(value)} />
                    </View>
                </View>
                <View style={styles.action_buttons_container}>
                    <TouchableOpacity disabled={qtd > 0 ? false : true} onPress={() => {
                        setModalVisible(false)
                        navigation.navigate('ConfirmPurchaseOrSell', { qtd: qtd, token: selectecdAsset.id, viewType: 'buy', market: true })
                    }
                    }>
                        <LinearGradient
                            start={{ x: -1, y: 0 }}
                            end={{ x: 1, y: 0 }}
                            colors={["#00490C", "#32BFB1"]}
                            style={styles.action_button}
                        >
                            <Text style={styles.action_button_text}>{saldoGPX > (qtd * parseFloat(selectecdAsset.single_value)) ? 'Comprar' : 'Sem saldo'}</Text>
                        </LinearGradient>
                    </TouchableOpacity>
                    {
                        saldo > 0 && saldo >= qtd ?
                            <TouchableOpacity disabled={qtd > 0 ? false : true} onPress={() => {
                                setModalVisible(false)
                                navigation.navigate('ConfirmPurchaseOrSell', { qtd: qtd, token: selectecdAsset.id, viewType: 'sell', market: true })
                            }}>
                                <LinearGradient
                                    start={{ x: -1, y: 0 }}
                                    end={{ x: 1, y: 0 }}
                                    colors={["#AA0000", "#FF5454"]}
                                    style={styles.action_button}
                                >
                                    <Text style={styles.action_button_text}>Vender</Text>
                                </LinearGradient>
                            </TouchableOpacity>
                            :
                            <TouchableOpacity>
                                <LinearGradient
                                    start={{ x: -1, y: 0 }}
                                    end={{ x: 1, y: 0 }}
                                    colors={["#AA0000", "#FF5454"]}
                                    style={styles.action_button}
                                >
                                    <Text style={styles.action_button_text}>Sem Saldo</Text>
                                </LinearGradient>
                            </TouchableOpacity>
                    }
                </View>
            </>
        );
    }
    const getTokensWallet = async () => {
        setLoading(true)
        const authToken = await AsyncStorage.getItem('JWT_TOKEN');
        activesService.getActivesWhereUserHasBalance(authToken).then((response) => {
            if (response.data.length > 0) {
                setListActives(response.data);
            }
            setLoading(false)
        }).catch((error) => {
            setLoading(false)
            console.log(error);
        });
    }

    function handleSelectedAsset(asset) {
        setModalVisible(true)
        setSelectedAsset(asset);
    }
    return <>
        {loading ? <View style={styles.center}><ActivityIndicator size="large" color="#1FBFB5" /></View> :
            <>
                <ScrollView contentContainerStyle={styles.scrollViewContent} nestedScrollEnabled={true}>
                    {listActives !== null ?
                        listActives.map((item, index) =>
                            <TouchableOpacity style={styles.contentItem}
                                onPress={() => handleSelectedAsset(item)}
                                key={index}>
                                {item.path ?
                                    <Image source={{ uri: 'https://filesgpx.s3.us-east-2.amazonaws.com/' + item.path }} style={styles.img} />
                                    :
                                    <Image source={require('../../../assets/home/icons/logo.png')} style={styles.img} />
                                }
                                <View style={styles.textsItem}>
                                    <Text style={styles.titleCoin}>{maxDecimals(item.balance, 8)} {item.name_token}</Text>
                                    <View style={styles.infoPrice}>
                                        <Text style={styles.infosCoin}>Valor:</Text>
                                        <Text style={styles.priceCoin}> {formatGPXBalance(item.single_value)} GPX</Text>
                                    </View>
                                </View>
                                <MaterialIcons
                                    name="keyboard-arrow-right"
                                    size={30}
                                    color="#2C2C2E"
                                    style={styles.iconGo}
                                />
                            </TouchableOpacity>)
                        : <Text style={styles.titleCoin}>Sem Ativos</Text>
                    }
                </ScrollView>

                <Modal animationType="fade" transparent={true} visible={modalVisible}>
                    <View style={styles.modalCenteredView}>
                        <View style={styles.modalView}>
                            <View style={styles.modalText}>
                                <View style={{ flexDirection: "row", justifyContent: 'flex-end' }}>
                                    <View>
                                        <MaterialIcons
                                            onPress={() => setModalVisible(!modalVisible)}
                                            name="close"
                                            size={30}
                                            color="black"
                                            style={styles.closeModal}
                                        />
                                    </View>
                                </View>
                                <BalanceInfo />
                                <ActionButtons />
                                <TouchableOpacity>
                                    <Text style={{ textAlign: 'center', color: 'blue' }}></Text>
                                </TouchableOpacity>
                                {
                                    //BOTÃO CERTIFICADO
                                    certificateEmit &&
                                    <TouchableOpacity onPress={() => {
                                        setModalVisible(false)
                                        navigation.navigate({ name: "Certificates", params: selectecdAsset })
                                    }}>
                                        <Text style={{ marginBottom: 20, textAlign: 'center', color: 'blue', fontSize: 18 }}>Emitir Certificado {'>>'}</Text>
                                    </TouchableOpacity>
                                }
                            </View>
                        </View>
                    </View>
                </Modal>
            </>
        }
    </>
}

export default CardsMyTokensWallet;